import { differenceInMinutes, startOfMinute } from 'date-fns';

import { Tag } from './TimeDifferenceTag.styles';

const EARLY = 'early';
const LATE = 'late';

interface ITimeDifferenceTag {
  prefix?: string;
  timeA: Nullable<Date>;
  timeB: Nullable<Date>;
  children?: React.ReactNode;
}

export const TimeDifferenceTag = ({ prefix, timeA, timeB }: ITimeDifferenceTag) => {
  if (!timeA || !timeB) {
    return null;
  }
  const diff = differenceInMinutes(startOfMinute(new Date(timeA)), new Date(timeB));
  const status = getStatus(diff);

  if (!status) {
    return null;
  }

  return <Tag $status={status}>{`(${prefix || ''}${Math.abs(diff)} min ${status})`}</Tag>;
};

const getStatus = (time) => {
  if (time < 0) {
    return EARLY;
  }
  if (time > 0) {
    return LATE;
  }

  return null;
};
